import './inputs.css'

// Controlled text input. onChange receives the next value directly.
function TextInput({ value = '', onChange, placeholder, disabled, type = 'text' }) {
  return (
    <input
      className="ct-input"
      type={type}
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      onChange={(event) => onChange?.(event.target.value)}
    />
  )
}

export default TextInput
